module.exports = __webpack_public_path__ + "static/media/createPaymentLink.mobile.4971dee9.svg";